import { FC, useEffect, useState } from "react";
import styles from "./Alert.module.scss";
import { Alert, useAlert } from "../Alert";
import { AlertData } from "./context";
import classNames from "classnames";
import { usePresence } from "../../hooks/usePresence";

// must match the alertEnter/alertExit animation duration in Alert.module.scss
const ANIMATION_DURATION_MS = 200;

/**
 * The alert container properties.
 */
export interface AlertContainerProps {
  /**
   * The current alert data.
   */
  readonly currentAlert: AlertData | null;
}

/**
 * The alert container component.
 * @deprecated Please use the component in `capitalrx-components-2.0/lib/general`.
 */
export const AlertContainer: FC<AlertContainerProps> = (props: AlertContainerProps): JSX.Element => {
  const { currentAlert } = props;
  const [activeAlert, setActiveAlert] = useState<AlertData | null>(null);

  const presence = usePresence(activeAlert, ANIMATION_DURATION_MS);

  const [, hideAlert] = useAlert();

  useEffect(() => {
    setActiveAlert(currentAlert);

    const timer = setTimeout(() => {
      hideAlert();
    }, currentAlert?.timeout || 5000);

    return () => {
      clearTimeout(timer);
    };
  }, [currentAlert]);

  return (
    <>
      {presence.map(({ item: alert, key, state, onAnimationEnd }) => (
        <div
          key={key}
          className={classNames(styles.alertContainer, state)}
          data-testid={"test__alert-container"}
          onAnimationEnd={onAnimationEnd}
        >
          <Alert message={alert.message} style={alert.style} type={alert.type} />
        </div>
      ))}
    </>
  );
};
